$(document).ready(function () {
  setTimeout(function() {
      $('.template-product .thumb img').on('click', function () {
        $(window).scrollTop($('.content').position().top);
      });
    }, 300);
   });

$(document).on("click", ".template-index .thumb", function(){
        $(window).scrollTop($('.product').position().top);
      });

$(function () {
  // メイン画像のオプション
  $(".fire").slick({
    autoplay: false, // 自動再生ON
    arrows: false, // 矢印非表示
    asNavFor: ".thumbnail", // サムネイルと同期
    infinite: false,
     adaptiveHeight: true
  });
  // サムネイルのオプション
  $(".thumbnail").slick({
    slidesToShow: 3, // サムネイルの表示数
    asNavFor: ".fire", // メイン画像と同期
    focusOnSelect: true, // サムネイルクリックを有効化
    infinite: false,
  });
});

  
  $(document).ready(function () {
    setInterval(function() {
  $('.y-image').each(function(index){
var size = $(this).find('.color-s').length;
 if(size > 0 ) {
   $(this).children('.nomal-slide').css('display','none');
   $(this).find('.lera').css('display','none');
 }else{
   $(this).find('.wena').css('display','none');
  $(this).children('.color-slide').css('display','none');
 }
           });
       }, 800);
});

$(document).ready(function () {
    setInterval(function() {
$('.y-image').each(function(index){

  var $tabAnchors = $(this).find('.wena a'),//タブのaタグ
        $panelInner = $(this).find('.color-slide'),//スライドする部分
        panelWidth = $panelInner.find('.color-s').width();//パネルのwidth

  //タブがクリックされたらタブのインデックス番号を取得し、
  //$panelInnerをタブのwidth*インデックス番号分leftを移動
  $tabAnchors.click(function(event){

      //デフォルトのaタグの動作をキャンセル
      event.preventDefault();

      var index = $(this).closest('li').index();//クリックされたタブのインデックス番号
      var fire = panelWidth * index
      $panelInner.scrollLeft(fire);
      // $panelInner.animate({
      //     left: -panelWidth * index  + 'px'
      // });
  });
});
      }, 800);
});

$(document).ready(function () {
   setInterval(function() {
$('.y-image').each(function(index){
   

  var $tabAnchors = $(this).find('.lera a'),//タブのaタグ
        $panelInner = $(this).find('.nomal-slide'),//スライドする部分
        panelWidth = $panelInner.find('.nomal-s').width();//パネルのwidth

  //タブがクリックされたらタブのインデックス番号を取得し、
  //$panelInnerをタブのwidth*インデックス番号分leftを移動
  $tabAnchors.click(function(event){

      //デフォルトのaタグの動作をキャンセル
      event.preventDefault();

      var index = $(this).closest('li').index();//クリックされたタブのインデックス番号
      var fire = panelWidth * index
      $panelInner.scrollLeft(fire);
      // $panelInner.animate({
      //     left: -panelWidth * index  + 'px'
      // });
  });
          
});
     }, 800);
});

$(document).ready(function() {
    $('.thumbnail .slick-slide').each(function(index){
$(this).addClass("lex"+(index+1));
});
  });

// $(document).ready(function () {
//       $('.y-color div').on('click', function () {
//         var sr = $(this).attr('class').split('lex');
//         var last = sr.slice(-1)[0];
//         var array = "lex"+ last;
//      $(".thumbnail ").find("."+ array).trigger("click"); 
//       });
//    });

$(document).ready(function() {
    $('.thumb').each(function(index){
      var sr = $(this).attr('class');
$(this).parent().parent().addClass(sr);
});
  });

$(document).ready(function () {
      $('.y-color div').on('click', function () {
        var sr = $(this).attr('class');
//           var array = "lex"+ sr;
     $(".thumbnail ").find("."+ sr).trigger("click"); 
      });
   });

// $(document).ready(function () {
//       $('.y-color div').on('click', function () {
//         var sr = $(this).attr('class').split('bay');
//         var las = sr.slice(-1)[0];
//         var fam = Number(las);
//         var order = 'nth-child(' + fam +')';
//         var cam = $(".c-y span:" + order).attr("class").split('lex'); 
//           var lay = cam.slice(-1)[0];
//           var array = "lex"+ lay;
//      $(".thumbnail ").find("."+ array).trigger("click"); 
//       });
//    });

// $(document).ready(function () {
//       $('.c-y span').on('click', function () {
//         var sr = $(this).attr('class').split('lex');
//         var last = sr.slice(-1)[0];
//        var array = "lex"+ last;
//      $(".thumbnail ").find("."+ array).trigger("click"); 
//       });
//    });
